<div class="d-flex flex-wrap pt-3">
  <p-expandable-text
    *ngIf="
      definitions && definitions.content && definitions.content.length > 0;
      else noContent
    "
    [text]="definitions.content"
    [maxLines]="3"
  ></p-expandable-text>

  <ng-template #noContent>
    <p>Non renseigné</p>
  </ng-template>
</div>
